import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Input,
  Icon,
  Avatar,
  Tooltip
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import axios from 'axios'
import { EQUIPMENT_CATEGORY, HERO_TYPE, HERO_TYPE_MESSAGE } from '../../utils/constants'
import Highlighter from 'react-highlight-words'
import WrappedHeroDetailForm from './components/HeroForm'
import WrappedEquipmentForm from './components/EquipmentForm'

const Quotation = () => {
  const dispatch = useDispatch()
  const [quotation, setQuotation] = useState([])
  const [searchText, setSearchText] = useState('')
  const [visibleHero, setVisibleHero] = useState(false)
  const [visible, setVisible] = useState(false)
  const [formDataHero, setFormDataHero] = useState({})
  const [formDataEquipment, setFormDataEquipment] = useState({})
  const [formDataSubEquipment, setFormDataSubEquipment] = useState({})
  const [formDataCategory, setFormDataCategory] = useState({})
  const [formDataSeller, setFormDataSeller] = useState({})
  let searchInput = useRef(null)

  async function fetchQuotation() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/quotation/all`
      )
      setQuotation(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const equipmentArr = []
  const subCategoryArr = []
  const sellerArr = []

  for (const item of quotation) {
    equipmentArr.push(
      item.equipment.name
    )
    subCategoryArr.push(
      item.equipment.subEquipment.name
    )
    sellerArr.push(
      item.equipment.seller.name
    )
  }

  useDeepEffect(() => {
    fetchQuotation()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClickHero = (e, record) => {
    e.preventDefault()
    setVisibleHero(true)
    setFormDataHero(record)
  }

  const onClickEquipment = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormDataEquipment(record.equipment)
    setFormDataSubEquipment(record.equipment.subEquipment)
    setFormDataCategory(record.equipment.subEquipment.category)
    setFormDataSeller(record.equipment.seller)
  }

  const onCloseModalHero = async () => {
    await setVisibleHero(false)
  }

  const onCloseModal = async () => {
    await setVisible(false)
  }

  const columns = [
    {
      title: 'ผู้ขอใบเสนอราคา',
      dataIndex: 'heroName',
      key: 'name',
      ...getColumnSearchProps('name'),
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
            color: 'blue' 
          }
        }
      },
      render: (text, record) => (
        <Tooltip title={text}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            <Avatar src={record.heroImage} size={48} />
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text.toString()}
              onClick={(e) => onClickHero(e, record)}
            />
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Hero Type',
      dataIndex: 'heroType',
      key: 'heroType',
      filters: HERO_TYPE.map(category => ({
        text: HERO_TYPE_MESSAGE[category],
        value: category
      })),
      onFilter: (value, record) => record.heroType === value,
      render: (text) => (
        <span>{text ? HERO_TYPE_MESSAGE[text] : text}</span>
      )
    },
    {
      title: 'เครื่องจักรอุปกรณ์',
      dataIndex: 'equipment.name',
      key: 'equipmentName',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      filters: equipmentArr.map(equipment => ({
        text: equipment,
        value: equipment
      })),
      onFilter: (value, record) => record.equipment.name === value,
      render: (name, record) => (
        <Tooltip title={name}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} onClick={(e) => onClickEquipment(e, record)}>
            <Avatar src={record.equipment.cover.url} size={48} />
            <span style={{ lineHeight: '45px'  , color: 'blue' }}> {name}</span>
          </div>
        </Tooltip>
      )
    },
    {
      title: 'หมวดหมู่',
      dataIndex: 'equipment.subEquipment.category.name',
      key: 'category',
      filters: EQUIPMENT_CATEGORY.map(category => ({
        text: category,
        value: category
      })),
      onFilter: (value, record) => record.equipment.subEquipment.category.name === value
    },
    {
      title: 'หมวดหมู่ย่อย',
      dataIndex: 'equipment.subEquipment.name',
      key: 'subCategory',
      filters: subCategoryArr.map(subCategory => ({
        text: subCategory,
        value: subCategory
      })),
      onFilter: (value, record) => record.equipment.subEquipment.name === value
    },
    {
      title: 'ผู้ขาย',
      dataIndex: 'equipment.seller.name',
      key: 'seller',
      filters: sellerArr.map(seller => ({
        text: seller,
        value: seller
      })),
      onFilter: (value, record) => record.equipment.seller.name === value,
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={record.equipment.seller.logo} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{text}</span>
          </Col>
        </Row>
      )
    },
  ]

  return (
    <Card
      title="Quotation">
      <Table
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={quotation}
        columns={columns}
      />
      <WrappedHeroDetailForm
        visible={visibleHero}
        onCancel={onCloseModalHero}
        formData={formDataHero}
      />
      <WrappedEquipmentForm
        visible={visible}
        onCancel={onCloseModal}
        formData={formDataEquipment}
        formDataSubEquipment={formDataSubEquipment}
        formDataCategory={formDataCategory}
        formDataSeller={formDataSeller}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Quotation)


// WEBPACK FOOTER //
// ./src/pages/Quotation/index.js